var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSablier(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_319",
    "data-name": "Groupe 319",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.146,
    height: 16.196,
    viewBox: "0 0 12.146 16.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2232",
    "data-name": "Rectangle 2232",
    width: 12.146,
    height: 16.196,
    fill: "#1b384c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_318",
    "data-name": "Groupe 318",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_458",
    "data-name": "Trac\\xE9 458",
    d: "M9.144,8.1a8.468,8.468,0,0,0,2.973-5.027A2.659,2.659,0,0,0,11.5.942,2.71,2.71,0,0,0,9.445,0H2.7A2.71,2.71,0,0,0,.648.943,2.661,2.661,0,0,0,.029,3.074,8.444,8.444,0,0,0,3,8.1a8.446,8.446,0,0,0-2.97,5.024,2.662,2.662,0,0,0,.619,2.131A2.709,2.709,0,0,0,2.7,16.2H9.444a2.711,2.711,0,0,0,2.054-.942,2.658,2.658,0,0,0,.62-2.129A8.47,8.47,0,0,0,9.144,8.1Zm1.331,6.275a1.36,1.36,0,0,1-1.031.474H2.7a1.359,1.359,0,0,1-1.031-.474,1.3,1.3,0,0,1-.308-1.05,7.567,7.567,0,0,1,3.1-4.7.675.675,0,0,0,0-1.058,7.567,7.567,0,0,1-3.1-4.7,1.294,1.294,0,0,1,.308-1.05A1.36,1.36,0,0,1,2.7,1.35H9.444a1.358,1.358,0,0,1,1.031.474,1.294,1.294,0,0,1,.307,1.048,7.6,7.6,0,0,1-3.105,4.7.676.676,0,0,0,0,1.057,7.6,7.6,0,0,1,3.105,4.7,1.292,1.292,0,0,1-.308,1.048ZM9.182,3.628A.675.675,0,0,0,8.557,2.7H3.587a.675.675,0,0,0-.626.928A7.554,7.554,0,0,0,5.3,6.51l.35.277a.675.675,0,0,0,.84,0l.343-.273A7.634,7.634,0,0,0,9.182,3.627ZM6.072,5.4A7.625,7.625,0,0,1,4.745,4.049H7.4A7.756,7.756,0,0,1,6.072,5.4",
    transform: "translate(0)",
    fill: "#1b384c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSablier);
export default __webpack_public_path__ + "static/media/sablier.f1e7202087210f6be9aa02d1bb9d8d3b.svg";
export { ForwardRef as ReactComponent };